import React, { useEffect } from 'react';
import { Grid } from '@mui/material';

import PlatesList from '@shared/components/PlatesList';
import { FormSearchAssist } from '@shared/pages/AssistCard/FormSearchAssist';
import ImageSlider from '@shared/components/ImageSlider';
import TabsHeader from '@shared/components/TabsHeader';

import { useHistory } from 'react-router';
import { ASSIST_SEARCH } from '@shared/helpers/routes';

export default () => {
  const history = useHistory();

  const setIsReadyToNavigate = v => {
    if (v) history.push(ASSIST_SEARCH);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ overflow: 'hidden' }}>
      <TabsHeader site={3} />
      <FormSearchAssist
        needsNavigate={true}
        isHomePage={true}
        setReady={value => setIsReadyToNavigate(value)}
      />

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        className="minWebPadding"
        style={{ backgroundColor: '#F2F2F2', paddingBottom: '50px' }}
      >
        <ImageSlider />

        <PlatesList
          title="Principales Destinos"
          IdServiceType={1}
          section={'main-destinations'}
          typePlate={0}
        />
        <PlatesList
          title="Propuestas Irresistibles"
          IdServiceType={4}
          section={'irresistible-packages'}
          typePlate={2}
        />
      </Grid>
    </div>
  );
};
